<template>
  <span v-if="hasRole">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    roles: {
      type: Array,
    },
  },
  computed: {
    hasRole() {
      return this.hasRxRole(this.roles);
    },
  },
};
</script>

<style>
</style>